import { serverApi } from '../api';

const DEFAULT_FAVICON = '/favicon.png';

export const setFavicon = (imageUrl) => {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }

    if (!imageUrl || typeof imageUrl !== 'string' || !imageUrl.trim()) {
        link.href = DEFAULT_FAVICON;
        return;
    }

    const base = serverApi.defaults.baseURL?.replace(/\/api\/?$/, '') || '';
    link.href = imageUrl.startsWith('http') ? imageUrl : `${base}${imageUrl.trim()}`;
};
